export default __webpack_public_path__ + "static/media/2371.edd24d06.png";